import React from 'react';
import { Button } from 'antd';
import styles from './not_found.module.css';
import notFoundLogo from 'assets/imgs/404_error.png';
import { Link } from 'react-router-dom';
import { getBaseRedirectUrl } from 'utils/tenant-util';
import { store } from 'store';

const NotFound = ({
  className = '',
  title = '404 Error - Path not Found',
  description = "The page you're looking for doesn't exist or may have been moved. Please check the URL or return to the homepage.",
  actionButton = (
    <Link to={getBaseRedirectUrl({ tenantData: store.getState()?.tenantConfigData?.tenantData })}>
      <Button className={'page-button mt-5'}>{'Back to Home'}</Button>
    </Link>
  ),
  logo = null,
}) => {
  return (
    <div className={`${styles.centerNotFound} ${className}`}>
      <img src={logo ?? notFoundLogo} alt="logo" />

      <div style={{ color: 'var(--text-main)' }} className="h3-semibold mt-4">
        {title}
      </div>

      <div style={{ color: 'var(--user-main-text)' }} className="body-14-medium">
        {description}
      </div>

      {actionButton}
    </div>
  );
};

export default NotFound;
